import { getAccountTrainCoursesFunctionDef } from '../../backend/config/classifiers/platform-functions/getAccountTrainCourses';
import { useCredentialingTranslation } from '../../ui/hooks';
import { formatDate } from '@juvare/common-web-ui/utils';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Button, CircularProgress, Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import useSWRInfinite from 'swr/infinite';
import { TrainCoursesTable, TrainCoursesTableRow } from './TrainCoursesTable';
const initialSize = 1;
const limit = 10;
const isLastPage = (total, page) => {
    return page * limit >= total;
};
export const TrainCoursesSection = ({ accountId, clientCode = '' }) => {
    const { t } = useCredentialingTranslation();
    const getAccountTrainCourses = useTypedPlatformFunction(getAccountTrainCoursesFunctionDef);
    const { data: accountTrainCourses, setSize, size, isValidating, } = useSWRInfinite((pageIndex, previousPageData) => {
        if (previousPageData && isLastPage(previousPageData.total, pageIndex))
            return null;
        return ['TrainCoursesSection', pageIndex];
    }, ([, pageIndex]) => getAccountTrainCourses({ accountId, limit, offset: pageIndex * limit }), { initialSize, fallbackData: [{ data: [], total: 0 }] });
    if (!accountTrainCourses) {
        return null;
    }
    const total = accountTrainCourses[0].total;
    const handleShowMore = () => {
        setSize((previousSize) => previousSize + 1);
    };
    return (React.createElement(Paper, { sx: { p: 2 }, variant: 'outlined' },
        React.createElement(Typography, { fontWeight: '500' }, t('trainCourses.title', { clientCode })),
        !!total && (React.createElement(React.Fragment, null,
            React.createElement(Box, { mt: 3 },
                React.createElement(TrainCoursesTable, null, accountTrainCourses.map((page) => page.data.map(({ completionDate, courseName, trainId }) => (React.createElement(TrainCoursesTableRow, { key: `${courseName}-${completionDate}`, courseDate: formatDate(new Date(completionDate)), courseNumber: trainId.toString(), courseName: courseName, verificationStatus: 'success' })))))),
            React.createElement(Stack, { mt: 3, alignItems: 'center' }, !isLastPage(total, size) && (React.createElement(Button, { size: 'small', startIcon: isValidating ? React.createElement(CircularProgress, { size: '20px' }) : React.createElement(ExpandMoreIcon, null), onClick: handleShowMore }, t('trainCourses.labels.showMore'))))))));
};
